'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconDebug, iconDebugTag } from '@ni/nimble-components/dist/esm/icons/debug';
import { wrap } from '../../utilities/react-wrapper';

export type { IconDebug };
export { iconDebugTag };
export const NimbleIconDebug = wrap(IconDebug);